import React from 'react';
import {connect} from "react-redux";
import { Icon as LegacyIcon } from '@ant-design/compatible';
import { Menu } from 'antd';

import {i18, trb} from '../../Utilities';
import {history, linkPath} from '../../Config';

import './index.less';

const {SubMenu} = Menu;

class PartMenu extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            current: window.location.pathname,
            selectedLinks: []
        };

        this.clickMenu = this.clickMenu.bind(this);
        this.saveSelectedLinks = this.saveSelectedLinks.bind(this);
    }

    componentDidMount() {
        this.saveSelectedLinks();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState.current !== window.location.pathname) {
            this.saveSelectedLinks();
        }
    }

    saveSelectedLinks = () => {
        if (window.location.pathname.split('/', 3).length === 3) {
            this.setState({
                current: window.location.pathname,
                selectedLinks: [window.location.pathname, '/' + window.location.pathname.split('/', 2).pop()]
            })
        } else {
            this.setState({
                current: window.location.pathname,
                selectedLinks: [window.location.pathname]
            })
        }
    };

    clickMenu = (e) => {
        if (e.key === window.location.pathname) {
            return null;
        }

        this.setState({
            current: e.key
        });

        if (this.props.media) {
            this.props.toggle();
        }

        history.push(e.key);
    };

    renderMenu = (advancedMenu) => {
        return advancedMenu.map((menu, index) =>
            menu.submenu ? (
                <SubMenu
                    key={index}
                    title={
                        <>
                            <LegacyIcon type={menu.icon} className="eb_fs_20"/><span>{trb(menu.title)}</span>
                        </>
                    }
                >
                    {menu.submenu.map((subMenu, index) =>
                        <Menu.Item key={subMenu.path}>
                            <span>{subMenu.withoutTranslate ? subMenu.title : trb(subMenu.title)}</span>
                        </Menu.Item>
                    )}
                </SubMenu>
            ) : (
                <Menu.Item key={menu.path}>
                    <LegacyIcon type={menu.icon} className="eb_fs_20"/><span>{trb(menu.title)}</span>
                </Menu.Item>
            )
        );
    }

    render() {
        const {companyNames, user} = this.props;
        if (!companyNames || !user) return <></>;

        const advancedMenu = [
            {
                title: i18.Menus.AllApplications,
                icon: 'ordered-list',
                path: linkPath.listKyc.url
            }
        ];

        if (this.props.media) {
            return (
                <Menu
                    className='eb_menu_mob'
                    onClick={(e) => this.clickMenu(e)}
                    mode="inline"
                    selectedKeys={this.state.selectedLinks}
                >
                    {this.renderMenu(advancedMenu)}
                </Menu>
            );
        }

        return <div className="eb_menu">
            <div className="main_inner">
                <Menu
                    className='eb_menu_links'
                    onClick={(e) => this.clickMenu(e)}
                    mode='horizontal'
                    selectedKeys={this.state.selectedLinks}
                >
                    {this.renderMenu(advancedMenu)}
                </Menu>
            </div>
        </div>
    };
}

function mapStateToProps(state) {
    const {companyNames, sendTools} = state.ToolsReducers;

    return {
        companyNames, sendTools
    };
}

const connectedPartMenu = connect(mapStateToProps)(PartMenu);
export {connectedPartMenu as PartMenu};
